// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Hero__heroContainer___pxtV6{margin-top:-64px;padding:104px 24px 80px;background-color:#fff4ee}.Hero__title___21jiZ{margin-top:16px;font-weight:200}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"heroContainer": "Hero__heroContainer___pxtV6",
	"title": "Hero__title___21jiZ"
};
module.exports = ___CSS_LOADER_EXPORT___;
